import { WpModes } from '../constants';
import { DbScope } from './dbScope';

// Synchronous, session-lifetime mirror of the last-known WpPostInfo per post/task.
// Lets setActivePostId2 prefill fields (e.g. tags) instantly, the same way it already
// prefills title/abbr/flag/snooze from the sidebar list row, without waiting on the
// async IndexedDB round-trip that DbUtils.wp_load_post_info/wp_load_task_info require.
const mem = new Map<string, any>();

// const keyOf = (wpMode: WpModes | null | undefined, postId: string) =>
//   (wpMode == WpModes.Task ? `tkpi_${postId}` : `wlpi_${postId}`);
// 20261020: per user (View-As switches user without a reload); no user -> no entry
const keyOf = (wpMode: WpModes | null | undefined, postId: string) => {
  const prefix = DbScope.prefix();
  return prefix ? prefix + (wpMode == WpModes.Task ? `tkpi_${postId}` : `wlpi_${postId}`) : null;
};

export const WpPostInfoMem = {
  set(wpMode: WpModes | null | undefined, postId: string | null | undefined, postInfo: any): void {
    if (!postId || !postInfo) return;
    const key = keyOf(wpMode, postId);
    if (key) mem.set(key, postInfo);
  },

  get(wpMode: WpModes | null | undefined, postId: string | null | undefined): any {
    if (!postId) return null;
    const key = keyOf(wpMode, postId);
    return key ? (mem.get(key) ?? null) : null;
  },

  remove(wpMode: WpModes | null | undefined, postId: string | null | undefined): void { // 20261021: task no longer viewable
    if (!postId) return;
    const key = keyOf(wpMode, postId);
    if (key) mem.delete(key);
  },

  clear(): void { // 20261020: logout
    mem.clear();
  },
};

DbScope.onClear(() => WpPostInfoMem.clear());
